import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetCartAPI } from '.';

type Props = {
  cartId: string;
};

export const useGetCartQuery = ({ cartId }: Props) => {
  const nav = useNavigate();

  const getCartAPI = useGetCartAPI();

  const cartQuery = useQuery({
    queryKey: ['cart', cartId],
    queryFn: () => getCartAPI(cartId),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: 0,
    enabled: !!cartId,
  });

  useEffect(() => {
    if (
      cartQuery.isError ||
      ((cartQuery.data === undefined || cartQuery.data === null) &&
        !cartQuery.isLoading &&
        cartQuery.isEnabled)
    ) {
      nav('/get', { state: { error: true, cartId } });
    }
  }, [
    cartQuery.isError,
    cartId,
    nav,
    cartQuery.data,
    cartQuery.isLoading,
    cartQuery.isEnabled,
  ]);

  return cartQuery;
};
